// FloatingVideoButton.jsx
import React, { useState } from "react";

export default function FloatingVideoButton({ youtubeUrl, isSecondFloatingButton = true }) {
  const [open, setOpen] = useState(false);

  // Converte automaticamente link do YouTube para embed
  const toEmbed = (url) => {
    if (!url) return "";
    const regex = /(?:v=|youtu\.be\/|shorts\/)([^&?/]+)/;
    const match = url.match(regex);
    if (!match) return url; // se não achar, usa original
    return `https://www.youtube.com/embed/${match[1]}`;
  };

  return (
    <>
      {/* Botão flutuante */}
      <button
        onClick={() => setOpen(true)}
        style={{
          zIndex: '999',
          position: "fixed",
          bottom: isSecondFloatingButton ? "180px" : "100px",
          right: "18px",
          backgroundColor: "#6C47FF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "28px",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        🎥
      </button>

      {/* Modal fullscreen */}
      {open && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.85)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            padding: 0
          }}
        >
          {/* Conteúdo: vídeo + botão fechar embaixo */}
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "#000",
              display: "flex",
              flexDirection: "column"
            }}
          >
            {/* Área do vídeo */}
            <div
              style={{
                flex: "1 1 auto",
                position: "relative"
              }}
            >
              <iframe
                src={toEmbed(youtubeUrl)}
                title="YouTube Tutorial"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0
                }}
                allow="fullscreen"
                allowFullScreen
              ></iframe>
            </div>

            {/* Botão fechar embaixo */}
            <button
              onClick={() => setOpen(false)}
              style={{
                flexShrink: 0,
                width: "100%",
                padding: "16px",
                background: "#6C47FF",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600"
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
